export var activityFilters = ["all activity", "sales", "minting"];
export var sortByList = ["latest first", "oldest first"];
//# sourceMappingURL=types.js.map